import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as AIIconSvg } from "../../assets/svg/ai.svg";

const AIIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <AIIconSvg fill="currentColor" />
    </SvgIcon>
  );
};

export { AIIcon };
